import * as i from 'types';

export const generateDefaultCarSummaryUsps = (car: i.Car) => {
  const defaultUsps = [];

  if (car.actionRadius)
    defaultUsps.push({ usp: `${car.actionRadius} km actieradius` });
  if (car.chargingTime)
    defaultUsps.push({ usp: `Opgeladen in ~${car.chargingTime} uur` });
  if (car.loadVolume)
    defaultUsps.push({ usp: `${car.loadVolume} m**3** laadvermogen` });

  return defaultUsps;
};
